import React from 'react'

import reservinAurinko from '../assets/reservinAurinko.png'
import reservinAuringonpaiste from '../assets/reservinAuringonpaiste.png'

export const SUN_START_TJ = 10
export const MAX_SUN_RISE_RATIO = 0.45
const MIN_RISING_SIZE = 220
const MAX_RISING_SIZE = 520
const MIN_SHINING_SIZE = 260
const MAX_SHINING_SIZE = 560

const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max)

export const getSunRiseProgress = (tj: number): number =>
  clamp((SUN_START_TJ - tj) / (SUN_START_TJ - 1), 0, 1)

export const getSunElevation = (tj: number, availableHeight: number, sunSize: number): number => {
  if (tj > SUN_START_TJ) {
    return 0
  }

  const centerTarget = Math.max(availableHeight * MAX_SUN_RISE_RATIO, availableHeight / 2)
  const targetBottom = Math.max(centerTarget - sunSize / 2, 0)
  return getSunRiseProgress(tj) * targetBottom
}

interface SunriseProps {
  tj: number
  width: number
  height: number
}

export const Sunrise: React.FC<SunriseProps> = ({ tj, width, height }) => {
  if (tj > SUN_START_TJ) {
    return null
  }

  const availableHeight = Math.max(height, 0)
  const risingSizeTarget = Math.min(width * 0.7, availableHeight * 0.8)
  const shiningSizeTarget = Math.min(width * 0.75, availableHeight * 0.85)

  const risingSize = clamp(risingSizeTarget, MIN_RISING_SIZE, MAX_RISING_SIZE)
  const shiningSize = clamp(shiningSizeTarget, MIN_SHINING_SIZE, MAX_SHINING_SIZE)

  const sunBottom = getSunElevation(tj, availableHeight, tj <= 0 ? shiningSize : risingSize)

  if (tj <= 0) {
    return (
      <div className="sunLayer">
        <img
          src={reservinAuringonpaiste}
          alt="Reservin auringonpaiste"
          className="sunImage sunImageShining"
          style={{
            width: shiningSize,
            height: shiningSize,
            top: 'auto',
            bottom: `${sunBottom}px`,
          }}
        />
      </div>
    )
  }

  return (
    <div className="sunLayer">
      <img
        src={reservinAurinko}
        alt="Reservin aurinko"
        className="sunImage sunImageRising"
        style={{
          width: risingSize,
          height: risingSize,
          bottom: `${sunBottom}px`,
        }}
      />
    </div>
  )
}
